import styled from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px 16px;
  border-radius: 24px;
  background-color: ${th('colors.white')};

  @media ${sizes.desktop} {
    flex-direction: row-reverse;
    align-items: center;
    gap: 32px;
    padding: 56px 48px;
    border-top-right-radius: 32px;
    border-top-left-radius: 32px;
  }
`;

export const BirdImg = styled.img`
  width: 100%;
  margin-bottom: 24px;
  max-width: 460px;

  @media ${sizes.desktop} {
    margin-bottom: 0;
  }

  @media ${sizes.largeDesktop} {
    max-width: 560px;
  }
`;

export const Infos = styled.div`
  > :not(:last-child) {
    margin-bottom: 4px;
  }
  @media ${sizes.desktop} {
    max-width: 450px;
    font-size: 20px;
    line-height: 28px;
  }
`;

export const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.desktop} {
    gap: 24px;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  line-height: 40px;

  @media ${sizes.desktop} {
    font-size: 48px;
    line-height: 48px;
  }
`;

export const Paragraph = styled.div`
  display: none;
  line-height: 24px;

  > ul {
    margin: 0;
    padding-left: 24px;
  }

  @media ${sizes.desktop} {
    display: block;
    font-size: 20px;
    line-height: 28px;
  }
`;

export const MobileParagraph = styled(Paragraph)`
  display: block;

  @media ${sizes.desktop} {
    display: none;
  }
`;

export const DashboardButton = styled(Button)`
  max-width: 540px;
`;

export const AppButton = styled(Button)`
  max-width: 540px;
  @media ${sizes.desktop} {
    display: none;
  }
`;

export const FeedbackContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${sizes.desktop} {
    flex-direction: row;
    align-items: center;
  }
`;

export const FeedbackText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  line-height: 20px;
  padding: 0 8px 0 0;
`;

export const FeedbackButton = styled(Button)`
  flex-shrink: 0;
  outline: 1.5px solid ${th('colors.fountainBlue-3')};
  color: ${th('colors.fountainBlue-3')};
  margin: 8px 0 0 0;

  @media ${sizes.desktop} {
    margin: 0;
  }
`;
